export const Menu = [
  // {
  //   title: "Favourites",
  //   path: "favourites",
  // },
  {
    title: "Company Filters",
    path: "companyFilters",
  },
  {
    title: "Contact Filters",
    path: "contactFilters",
  },
  {
    title: "Software & Systems",
    path: "softwareSystems",
  },
  {
    title: "Industries",
    path: "industries",
  },
  {
    title: "Regional Filters",
    path: "regionalFilters",
  },
  {
    title: "News & Trigger Events",
    path: "triggerEvents",
  },
  {
    title: "Financial Figures",
    path: "financialFigures",
  },
  // {
  //   title: "Filters for Lists",
  //   path: "filtersForLists",
  // },
];

export const EditMenu = [
  {
    title: "Company Filters",
    path: "companyFilters",
  },
  {
    title: "Contact Filters",
    path: "contactFilters",
  },
  {
    title: "Software & Systems",
    path: "softwareSystems",
  },
  {
    title: "Industries",
    path: "industries",
  },
  {
    title: "Regional Filters",
    path: "regionalFilters",
  },
  {
    title: "News & Trigger Events",
    path: "triggerEvents",
  },
  {
    title: "Financial Figures",
    path: "financialFigures",
  },
  // {
  //   title: "Filters for Lists",
  //   path: "filtersForLists",
  // },
];

export const SoftwareSystemsData = [
  // {
  //   name:"Shopify",
  //   icon:<FaShopify />
  // }
  "Magento",
  "Shopware",
  "xtcommerce",
  "OXID eShop",
  "Shopify",
  "osCommerce",
  "WooCommerce",
  "epages",
  "Intershop",
  "Virtue Mart",
  "Prestashop",
  "Smartstore",
  "Bigcommerce",
  "Salesforce Commerce Cloud",
  "Plentymarkets",
];

export const TriggerEventsData = [
  "Construction projects",
  "Events",
  "Expansion",
  "Financial decline",
  "Financial growth",
  "Job Offers",
  "Negative events",
  "Personal Change",
  "Positive events",
  "Register trigger events",
];

export const CompanyFiltersData = [
  {
    title: "Company Search",
    description: "Include or exclude specific companies",
    path: "companySearch",
    image:'/public/assets/images/company-filter1.svg'
  },
  {
    title: "Website Content",
    description: "Include or exclude specific companies",
    path: "websiteContent",
    image:'/public/assets/images/company-filter2.svg'

  },
  {
    title: "Keywords & Topics",
    description: "Include or exclude specific companies",
    path: "keywordsAndTopics",
    image:'/public/assets/images/company-filter3.svg'

  },
  {
    title: "Company Size",
    description: "Include or exclude specific companies",
    path: "companySize",
    image:'/public/assets/images/company-filter4.svg'

  },
  {
    title: "Company Profile Completeness",
    description: "Include or exclude specific companies",
    path: "companyProfileCompleteness",
    image:'/public/assets/images/company-filter5.svg'

  },
  // {
  //   title: "CRM Status",
  //   description: "Include or exclude specific companies",
  //   path: "crmStatus",
  // },
];

export const IndustryFiltersData = [
  {
    title: "Industry",
    description: "Include or exclude specific companies",
    path: "industry",
  },
  {
    title: "Industry WZ Codes",
    description: "Include or exclude specific companies",
    path: "industryWZ",
  },
  {
    title: "Industry NACE Codes",
    description: "Include or exclude specific companies",
    path: "industryNACE",
  },
];


export const IndustriesData = {
  "Accommodation and Food Services": ["Food and Beverage Services", "Hospitality"],
  "Administrative and Support Services": ["Collection Agencies", "Events Services", "Facilities Services", "Fundraising", "Office Administration", "Security and Investigations", "Staffing and Recruiting", "Telephone Call Centers", "Translation and Localization", "Travel Arrangements", "Writing and Editing"],
  "Construction": ["Building Construction", "Civil Engineering", "Specialty Trade Contractors"],
  "Consumer Services": ["Civic and Social Organizations", "Household Services", "Non-profit Organizations", "Personal and Laundry Services", "Philanthropic Fundraising Services", "Religious Institutions", "Repair and Maintenance"],
  "Education": ["E-Learning Providers", "Higher Education", "Primary and Secondary Education", "Professional Training and Coaching", "Technical and Vocational Training"],
  "Entertainment Providers": ["Artists and Writers", "Museums, Historical Sites, and Zoos", "Musicians", "Performing Arts and Spectator Sports", "Recreational Facilities", "Spectator Sports"],
  "Farming, Ranching, Forestry": ["Farming", "Forestry and Logging", "Ranching and Fisheries"],
  "Financial Services": ["Capital Markets", "Credit Intermediation", "Funds and Trusts", "Insurance"],
  "Government Administration": ["Administration of Justice", "Economic Programs", "Environmental Quality Programs", "Health and Human Services", "Housing and Community Development", "Military and International Affairs", "Public Policy Offices", "Space Research and Technology"],  "Holding Companies": ["Holding Companies"],
  "Hospitals and Health Care": [
    "Community Services",
    "Hospitals",
    "Individual and Family Services",
    "Medical Practices",
    "Nursing Homes and Residential Care Facilities"
  ],
  "Manufacturing": [
    "Apparel Manufacturing",
    "Appliances, Electrical, and Electronics Manufacturing",
    "Chemical Manufacturing",
    "Climate Technology Product Manufacturing",
    "Computers and Electronics Manufacturing",
    "Fabricated Metal Products",
    "Food and Beverage Manufacturing",
    "Furniture and Home Furnishings Manufacturing",
    "Glass, Ceramics and Concrete Manufacturing",
    "Leather Product Manufacturing",
    "Machinery Manufacturing",
    "Medical Equipment Manufacturing",
    "Oil and Coal Product Manufacturing",
    "Paper and Forest Product Manufacturing",
    "Plastics and Rubber Product Manufacturing",
    "Primary Metal Manufacturing",
    "Printing Services",
    "Sporting Goods Manufacturing",
    "Tobacco Manufacturing",
    "Transportation Equipment Manufacturing",
    "Wood Product Manufacturing"
  ],
  "Oil, Gas, and Mining": [
    "Mining",
    "Oil and Gas"
  ],
  "Professional Services": [
    "Accounting",
    "Advertising Services",
    "Architecture and Planning",
    "Business Consulting and Services",
    "Design Services",
    "Engineering Services",
    "IT Services and IT Consulting",
    "Legal Services",
    "Research Services"
  ],
  "Real Estate and Equipment Rental Services": [
    "Equipment Rental Services",
    "Real Estate"
  ],
  "Retail": [
    "Food and Beverage Retail",
    "Online and Mail Order Retail",
    "Retail Apparel and Fashion",
    "Retail Appliances, Electrical, and Electronic Equipment",
    "Retail Art Dealers",
    "Retail Art Supplies",
    "Retail Books and Printed News",
    "Retail Building Materials and Garden Equipment",
    "Retail Florists",
    "Retail Furniture and Home Furnishings",
    "Retail Gasoline",
    "Retail Health and Personal Care Products",
    "Retail Luxury Goods and Jewelry",
    "Retail Motor Vehicles",
    "Retail Musical Instruments",
    "Retail Office Equipment",
    "Retail Office Supplies and Gifts",
    "Retail Recyclable Materials & Used Merchandise"
  ],
  "Technology, Information and Media": [
    "Media and Telecommunications",
    "Technology, Information and Internet"
  ],
  "Transportation, Logistics, Supply Chain and Storage": [
    "Airlines and Aviation",
    "Freight and Package Transportation",
    "Ground Passenger Transportation",
    "Maritime Transportation",
    "Pipeline Transportation",
    "Postal Services",
    "Rail Transportation",
    "Truck Transportation",
    "Warehousing and Storage"
  ],
  "Utilities": [
    "Electric Power Generation",
    "Electric Power Transmission, Control, and Distribution",
    "Natural Gas Distribution",
    "Water, Waste, Steam, and Air Conditioning Services"
  ],
  "Wholesale": [
    "Wholesale Alcoholic Beverages",
    "Wholesale Apparel and Sewing Supplies",
    "Wholesale Appliances, Electrical, and Electronics",
    "Wholesale Building Materials",
    "Wholesale Chemical and Allied Products",
    "Wholesale Computer Equipment",
    "Wholesale Drugs and Sundries",
    "Wholesale Food and Beverage",
    "Wholesale Footwear",
    "Wholesale Furniture and Home Furnishings",
    "Wholesale Hardware, Plumbing, Heating Equipment",
    "Wholesale Import and Export",
    "Wholesale Luxury Goods and Jewelry",
    "Wholesale Machinery",
    "Wholesale Metals and Minerals",
    "Wholesale Motor Vehicles and Parts",
    "Wholesale Paper Products",
    "Wholesale Petroleum and Petroleum Products",
    "Wholesale Photography Equipment and Supplies",
    "Wholesale Raw Farm Products",
    "Wholesale Recyclable Materials"
  ]
};

export const IndustriesCodesData = [
  "Agriculture, forestry and fishing",
  "Mining and quarrying",
  "Manufacturing",
  "Electricity, gas, steam and air conditioning supply",
  "water supply; sewerage, waste management and remediation activities",
  "Construction",
  "Transport & Storage",
  "Accomodation & food service activities",
  "Information & Communication",
];

export const ContactFiltersData = [
  {
    title: "Department Hierarchy",
    description: "Include or exclude specific companies",
    path: "departmentHierarchy",
  },
  {
    title: "Job Title Search",
    description: "Include or exclude specific companies",
    path: "jobTitleSearch",
  },
  {
    title: "Contact Location",
    description: "Include or exclude specific companies",
    path: "contactLocation",
  },
  {
    title: "Contact Profile Completeness",
    description: "Include or exclude specific companies",
    path: "contactProfileCompleteness",
  },
];

export const ContactDeptData = [
  "Business & Project Management",
  "Consulting",
  "Corporate Management",
  "Engineering",
  "Finance & Controlling",
  "Human Resources",
  "IT",
  "Legal & Compliance",
  "Logistics",
  "Marketing",
  "Media & Communication",
  "Procurement",
  "Product Management",
  "Production",
  "Quality Management",
  "Research and Development",
  "Sales",
  "Students & Apprentices",
  "Support",
  "Others"
];

export const RegionalFiltersData = [
  {
    title: "Country Filter",
    description: "Include or exclude specific companies",
    path: "countryFilters",
  },
  {
    title: "Radius",
    description: "Include or exclude specific companies",
    path: "radius",
  },
];

const filters = {
  companyFilters: {
    companySearch: {
      options: ["a", "b"],
    },
    websiteContent: {
      options: ["a", "b"],
    },
    keywordsAndTopics: {
      options: ["a", "b"],
      suggestions: ["a", "b"],
    },
    companySize: {
      from: 1,
      to: 1000,
    },
    companyProfile: {
      requirements: ["a", "b"],
      socialMediaAccounts: ["a", "b"],
      completenessPercentage: 90,
    },
  },
  contactFilters: {
    departmentHierarchy: {
      options: ["a", "b"],
      hierarchyLevel: ["a", "b"],
    },
    jobTitleSearch: {
      suggestions: ["a", "b"],
    },
    contactLocation: {
      countries: ["a", "b"],
    },
    contactProfile: {
      phoneNumber: ["a", "b"],
      sources: ["a", "b"],
      email: ["a", "b"],
    },
  },
  softwareAndSystems: {
    events: ["a", "b"],
    include: ["a"],
  },
  industries: {
    industry: {
      options: ["a", "b"],
    },
    wzCodes: {
      options: ["a", "b"],
    },
    naceCodes: {
      options: ["a", "b"],
    },
  },
  regionalFilters: {
    countryFilter: {
      countries: ["a", "b"],
    },
    radius: {
      location: "rftghj",
      radius: 10,
    },
  },
  newsAndTriggerEvents: {
    events: ["a", "b"],
    publicationPeriod: "abc",
    eventDate: "abc",
    searchCriteria: "abcdefghjk,",
  },
  finanacialFigures: {
    from: 1,
    to: 1000,
  },
};
